import { render, staticRenderFns } from "./AllTagsSection.vue?vue&type=template&id=632eb63e&scoped=true&"
import script from "./AllTagsSection.vue?vue&type=script&lang=ts&"
export * from "./AllTagsSection.vue?vue&type=script&lang=ts&"
import style0 from "./AllTagsSection.vue?vue&type=style&index=0&id=632eb63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632eb63e",
  null
  
)

export default component.exports